const PLACEHOLDER = '---';
const SUBSCRIPTIONS_CHANNEL_KEY = 'online-subscription';

export { PLACEHOLDER, SUBSCRIPTIONS_CHANNEL_KEY };
//# sourceMappingURL=constants.js.map
